import snapppayDesktop from "@website/accommodation-ui/hotel-snapp-pay/assets/snapppay-desktop.png";
import snapppayMobile from "@website/accommodation-ui/hotel-snapp-pay/assets/snapppay-mobile.png";
import { hotelSnappPayPropertiesType } from "@website/accommodation-ui/hotel-snapp-pay/hotel-snapp-pay.types";
import { useJwtToken } from "@website/hooks/auth";
import { MaterialIcon } from "@website/icons/material";
import { WEBENGAGE_EVENTS } from "@website/tracking/tracking.types";
import { addEventToWebengage } from "@website/tracking/tracking.webengage";
import { LazyImage } from "@website/ui/lazy-image";
import { deepCompare } from "@website/utils/deep-compare";
import { memo, useEffect } from "react";

const Component = ({
  isEligible,
  condition = "instalmentActive"
}: hotelSnappPayPropertiesType) => {
  const { phoneNumber } = useJwtToken();

  useEffect(() => {
    if (isEligible && phoneNumber) {
      addEventToWebengage(WEBENGAGE_EVENTS.PAY_BANNER_IMPRESSION, {
        "user phone number": phoneNumber
      });
    }
  }, [isEligible, phoneNumber]);

  return isEligible ? (
    condition === "instalmentActive" ? (
      <div className="border-ventures-fin-tech w-full rounded-lg border p-4 text-white">
        <div className="flex flex-row items-center gap-2">
          <MaterialIcon
            className="text-ventures-fin-tech"
            name="check_circle"
          />
          <div className="text-body-2 text-ventures-fin-tech">
            پرداخت قسطی با اسنپ‌پی برای شما فعال است.
          </div>
        </div>
      </div>
    ) : (
      <div className="border-ventures-fin-tech w-full overflow-hidden rounded-lg border">
        <div className="hidden md:block">
          <LazyImage src={snapppayDesktop?.src} />
        </div>
        <div className="block md:hidden">
          <LazyImage src={snapppayMobile?.src} />
        </div>
      </div>
    )
  ) : null;
};

export const HotelSnappPay = memo(Component, deepCompare);
